import React, { useContext, useEffect, useState } from "react";
import { translateImage } from "../../../images/images";
import {
    endAudios,
    muteAudio,
    playVoiceOver,
    stopAudio,
} from "../../../utils/handleVoiceAndLang";
import {
    hybridPosvSteps,
    isNpsSteps,
    photoVerificationSteps,
    QCSteps,
} from "../../../utils/stepperStep";
import HeadStepper from "../../HeadStepper/HeadStepper";
import "./LanguageSelect.css";
import "./LanguageSelectNew.css";
import { languageList } from "../../../utils/selectionLanguages";
import { polygonIcon } from "../../../images/btnIcons";
import searchIcon from "../../../images/searchIcon.png";
import { isNewUI, isPODPosv } from "../../../utils/handleProgress";
import { SpeakerContext } from "../../../context/SpeakerContext";
import { Button } from 'unified-ui-components-library'

function LanguageSelect(props) {
    const { showAllLangs, setShowAllLangs, supressVoiceOver } = props;
    const [journeyBy, setJourneyBy] = useState(localStorage.getItem("journeyBy"));
    const lPosv = localStorage.getItem("lPosv");
    console.log({ lPosv })
    const SLICE_LENGTH = journeyBy === 'P' ? ( lPosv === 'true' ? 6 : 1 ): 6
    const { isVoiceOverDisable } = useContext(SpeakerContext);
    const [selectedLanguage, setSelectedLanguage] = useState("");
    const [languages, setLanguages] = useState(languageList.slice(0, SLICE_LENGTH));
    // const [showAllLangs, setShowAllLangs] = useState(false)
    const [searchKey, setSearchKey] = useState("");

    const [isNps, setIsNps] = useState(localStorage.getItem("isNps"));
    const [isVideoPosv, setIsVideoPosv] = useState(
        localStorage.getItem("isVideoPosv")
    );
    const [isUlipPlancode, setIsUlipPlancode] = useState(
        localStorage.getItem("isUlipPlancode")
    );
    const [endAudio, setEndAudio] = useState(false);
    const [twoStep, setTwoStep] = useState(localStorage.getItem("twoStep"));

    useEffect(() => {
        if (!searchKey) {
            if (showAllLangs) {
                setLanguages(languageList);
            }
        } else {
            let allLanguages = JSON.parse(JSON.stringify(languageList));
            let searchResult = allLanguages.filter(({ nameEng }) =>
                nameEng.toLowerCase().includes(searchKey.toLowerCase())
            );
            setLanguages(searchResult);
        }
    }, [searchKey]);

    const logFun = () => {
        props.selectLanguage(selectedLanguage);
        stopAudio("verify-aud");
    };

    const sound = (lang) => {
        setSelectedLanguage(lang);
        let isNps = localStorage.getItem('isNps')
        if (isNps === 'Y' || (journeyBy === 'P' && lPosv === 'false') || supressVoiceOver === "Y" || isPODPosv()) {
            setEndAudio(true)
            stopAudio("verify-aud")
            return
        }
        if (isVoiceOverDisable) {
            muteAudio("verify-aud");
        }
        // stopAudio('verify-aud')
        setEndAudio(false);
        if (isUlipPlancode === "Y") {
            if (lang == "eng") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "eng");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Marathi") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "Marathi");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Bengali") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "Bengali");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Punjabi") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "Punjabi");
                endAudios("verify-aud", setEndAudio);
                // stopAudio('verify-aud')
                // setEndAudio(true)
            } else if (lang == "Manipuri") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "Manipuri");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Odiya") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "Odiya");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Gujarati") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "Gujarati");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Bhojpuri") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "Bhojpuri");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Urdu") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "Urdu");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Telugu") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "Telugu");
                endAudios("verify-aud", setEndAudio);
            }
            // else if (lang == "Gujarati") {
            //     playVoiceOver('verify-aud', 'uliplangselectionpage', 'Gujarati')
            //     endAudios('verify-aud', setEndAudio)
            // }
            else if (lang == "Assamese") {
                // stopAudio('verify-aud')
                // setEndAudio(true)
                playVoiceOver("verify-aud", "uliplangselectionpage", "Assamese");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Kannada") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "Kannada");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Malayalam") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "Malayalam");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Tamil") {
                playVoiceOver("verify-aud", "uliplangselectionpage", "Tamil");
                endAudios("verify-aud", setEndAudio);
            } else {
                playVoiceOver("verify-aud", "ulipLangselectionPage", "hin");
                endAudios("verify-aud", setEndAudio);
            }
        } else {
            if (lang == "eng") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "eng");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Bengali") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Bengali");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Marathi") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Marathi");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Punjabi") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Punjabi");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Telugu") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Telugu");
                endAudios("verify-aud", setEndAudio);
            }
            // else if (lang == "Gujarati") {
            //     playVoiceOver('verify-aud', 'nonuliplangselectionpage', 'Gujarati')
            //     endAudios('verify-aud', setEndAudio)
            // }
            else if (lang == "Assamese") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Assamese");
                endAudios("verify-aud", setEndAudio);
                // stopAudio('verify-aud')
                // setEndAudio(true)
            } else if (lang == "Kannada") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Kannada");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Malayalam") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Malayalam");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Tamil") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Tamil");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Manipuri") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Manipuri");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Odiya") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Odiya");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Gujarati") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Gujarati");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Bhojpuri") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Bhojpuri");
                endAudios("verify-aud", setEndAudio);
            } else if (lang == "Urdu") {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "Urdu");
                endAudios("verify-aud", setEndAudio);
            } else {
                playVoiceOver("verify-aud", "nonuliplangselectionpage", "hin");
                endAudios("verify-aud", setEndAudio);
            }
        }
    };

    const getSteps = () => {
        if (isNps == "Y" || journeyBy == "P") {
            return isNpsSteps;
        } else if (isVideoPosv == "Y") {
            return hybridPosvSteps;
        } else if (twoStep == "Y") {
            return QCSteps;
        } else {
            return photoVerificationSteps;
        }
    };

    const handleShowAllLangs = () => {
        setShowAllLangs(true);
        setLanguages(languageList);
    };

    const audioCompletionRequiredCheck = () => {
        if (isNewUI()) {
            return false;
        }
        return !endAudio;
    };

    const handleSearchInput = (e) => {
        setSearchKey(e.target.value);
        setSelectedLanguage("");
    };

    return (
        <>
            <audio className="aud-el-hide" id="lang-page-aud"></audio>
            {isNewUI() && !showAllLangs && (
                !isPODPosv && <div className="audioText">
                    An audio guide is available throughout the process, you can adjust the
                    volume accordingly.{" "}
                    <img src={polygonIcon} className="audioText_img" alt="img" />{" "}
                </div>
            )}
            {isNewUI() ? (
                <div
                    className={
                        showAllLangs
                            ? "selectLanguageWrapper verify-page-lang-cntnr"
                            : "selectLanguageWrapper"
                    }
                >
                    <div className="lang-header-cntnr">
                        <p>Please select your preferred language</p>
                        {showAllLangs && (
                            <div className="searchLanguage">
                                <input
                                    value={searchKey}
                                    onChange={handleSearchInput}
                                    className="inputSearch"
                                    type="text"
                                    placeholder="Search"
                                />
                                <img
                                    className="search-icon"
                                    src={searchIcon}
                                    alt="search_icn"
                                />
                            </div>
                        )}
                    </div>
                    <ul className="languageList">
                        {languages.map(({ code, name, nameEng }) => (
                            <li
                                key={code}
                                onClick={() => sound(code)}
                                className={selectedLanguage == code ? "activeLang" : ""}
                            >
                                <p
                                    className={
                                        nameEng == "Manipuri"
                                            ? "manipuri-font lang-name"
                                            : "lang-name"
                                    }
                                >
                                    {name}
                                </p>
                                <span>{nameEng !== "english" ? nameEng : ""}</span>
                            </li>
                        ))}
                    </ul>
                    {}
                    {((journeyBy === 'P' && lPosv === 'true') || journeyBy !== "P") && !showAllLangs && (
                        <Button onClick={handleShowAllLangs} buttonType="neutralLink" size="small">
                            Other Languages →
                        </Button>
                    )}
                    <div className="btnNextWrapper">
                    <Button
                            disabled={!selectedLanguage}
                            type="submit"
                            onClick={() => logFun()}
                            className="btnNext"
                            width="264"
                            buttonType="primary"
                        >
                            Next
                        </Button>   
                    </div>
                </div>
            ) : (
                <div className="language-screen">
                    <HeadStepper activeState={0} allSteps={getSteps()} />

                    <div className="language-contaner">
                        <div className="translate-cntnr">
                            <div className="translate-image-container">
                                <img className="translate-image" src={translateImage} alt="" />
                            </div>

                            <div className="test-display-container">
                                <span className="test-display">
                                    Before we move on to the next step, first select your
                                    preferred language
                                </span>
                            </div>
                        </div>
                        <div className="language-select-container">
                            <div className="lang">
                                <div className="languages">
                                    {props.simplifiedJourney == "y" ? (
                                        <>
                                            <p
                                                className={`languageOption languageOption-left ${selectedLanguage == "eng" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("eng")}
                                            >
                                                English
                                            </p>
                                            <p
                                                className={`languageOption languageOption-right ${selectedLanguage == "hin" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("hin")}
                                            >
                                                हिंदी
                                            </p>
                                            <div className="line-hr"></div>
                                            <p
                                                className={`languageOption languageOption-left ${selectedLanguage == "Bengali" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Bengali")}
                                            >
                                                বাংলা
                                            </p>
                                            <p
                                                className={`languageOption languageOption-right ${selectedLanguage == "Marathi" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Marathi")}
                                            >
                                                मराठी
                                            </p>
                                            <div className="line-hr"></div>
                                            <p
                                                className={`languageOption languageOption-left ${selectedLanguage == "Punjabi" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Punjabi")}
                                            >
                                                ਪੰਜਾਬੀ
                                            </p>
                                            <p
                                                className={`languageOption languageOption-right ${selectedLanguage == "Telugu" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Telugu")}
                                            >
                                                తెలుగు
                                            </p>
                                            <div className="line-hr"></div>
                                            <p
                                                className={`languageOption languageOption-left ${selectedLanguage == "Assamese" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Assamese")}
                                            >
                                                অসমীয়া
                                            </p>
                                            <p
                                                className={`languageOption languageOption-right ${selectedLanguage == "Kannada" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Kannada")}
                                            >
                                                ಕನ್ನಡ
                                            </p>
                                            <div className="line-hr"></div>
                                            <p
                                                className={`languageOption languageOption-left ${selectedLanguage == "Malayalam" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Malayalam")}
                                            >
                                                മലയാളം
                                            </p>
                                            <p
                                                className={`languageOption languageOption-right ${selectedLanguage == "Tamil" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Tamil")}
                                            >
                                                தமிழ்
                                            </p>
                                            <div className="line-hr"></div>
                                            <p
                                                className={`languageOption languageOption-left ${selectedLanguage == "Bhojpuri" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Bhojpuri")}
                                            >
                                                भोजपुरी
                                            </p>
                                            <p
                                                className={`languageOption languageOption-right ${selectedLanguage == "Urdu" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Urdu")}
                                            >
                                                اردو
                                            </p>
                                            <div className="line-hr"></div>
                                            <p
                                                className={`languageOption languageOption-left ${selectedLanguage == "Odiya" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Odiya")}
                                            >
                                                ଓଡ଼ିଆ
                                            </p>
                                            <p
                                                className={`languageOption languageOption-right ${selectedLanguage == "Gujarati" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Gujarati")}
                                            >
                                                ગુજરાતી
                                            </p>

                                            {/* <div className="line-hr"></div>
                                            <p
                                                className={`languageOption languageOption-left manipuri-font ${selectedLanguage == "Manipuri" ? "active-lang" : ""
                                                    }`}
                                                onClick={() => sound("Manipuri")}
                                            >
                                                ꯃꯅꯤꯄꯨꯔꯤꯗꯥ ꯂꯩꯕꯥ꯫
                                            </p> */}
                                        </>
                                    ) : (
                                        <>
                                            <p
                                                className={
                                                    selectedLanguage == "eng" ? "active-lang" : ""
                                                }
                                                onClick={() => sound("eng")}
                                            >
                                                English
                                            </p>
                                            <div className="line-hr"></div>
                                            <p
                                                className={
                                                    selectedLanguage == "hin" ? "active-lang" : ""
                                                }
                                                onClick={() => sound("hin")}
                                            >
                                                हिंदी
                                            </p>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="select-language-btn">
                            <button
                                className="cntnu-btn"
                                disabled={!selectedLanguage || endAudio == false}
                                type="submit"
                                onClick={() => logFun()}
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default LanguageSelect;
